(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  /*
    Buiten het uitklapmenu klikken sluit het. Een <details> blijft anders
    openstaan tot je precies weer op het knopje klikt, en dat is bij een klein
    menu in de bovenbalk lastig terugvinden.
  */
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-locale][open]').forEach((locale) => {
      if (!locale.contains(event.target)) locale.open = false;
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-locale][open]').forEach((locale) => {
      locale.open = false;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  /*
    Aantal wijzigen zonder de pagina te herladen.

    De knoppen zijn `submit`-knoppen die het ook zonder dit script doen — dan
    verzendt de browser het formulier en komt de bezoeker met een verse pagina
    terug. Dit script vangt de klik af, past de regel aan via de winkelwagen-API
    en haalt daarna alleen deze sectie opnieuw op.

    De header wordt apart ververst, want het aantal naast het winkelmandje en
    de inhoud van de lade staan daar en die kloppen anders niet meer.
  */
  class CartPage {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('[data-cart-form]');
      if (!this.form) return;

      this.busy = false;
      this.form.addEventListener('click', (event) => this.onClick(event));
    }

    async onClick(event) {
      const button = event.target.closest('[data-quantity]');
      if (!button) return;

      event.preventDefault();
      if (this.busy) return;

      const line = button.closest('[data-line]');
      if (!line) return;

      this.busy = true;
      this.form.setAttribute('aria-busy', 'true');

      try {
        const prefix = window.Shopify?.routes?.root || '/';
        await fetch(`${prefix}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line: Number(line.dataset.line),
            quantity: Number(button.dataset.quantity),
          }),
        });

        await this.refresh(prefix);
      } catch (error) {
        // Netwerk weg: dan maar de gewone weg, zodat de bezoeker niet met een
        // stille mislukking blijft zitten.
        this.form.submit();
        return;
      }

      this.busy = false;
      this.form.removeAttribute('aria-busy');
    }

    async refresh(prefix) {
      const id = this.root.dataset.sectionId;
      const [self, header] = await Promise.all([
        fetch(`${prefix}cart?sections=${id}`).then((r) => r.json()),
        fetch(`${prefix}?sections=header`).then((r) => r.json()).catch(() => null),
      ]);

      const fresh = new DOMParser().parseFromString(self[id], 'text/html');
      const next = fresh.querySelector('.cart-page__inner');
      const current = this.root.querySelector('.cart-page__inner');
      if (next && current) current.replaceWith(next);

      if (header?.header) {
        const freshHeader = new DOMParser().parseFromString(header.header, 'text/html');
        const nextCount = freshHeader.querySelector('.header__cart-count');
        const summary = document.querySelector('.header__cart summary');
        const currentCount = summary?.querySelector('.header__cart-count');

        if (currentCount && nextCount) currentCount.textContent = nextCount.textContent;
        else if (nextCount && summary) summary.append(nextCount);
        else if (currentCount) currentCount.remove();
      }
    }
  }

  document.querySelectorAll('.cart-page').forEach((root) => new CartPage(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  /*
    De sorteerkeuze verstuurt zichzelf. Er staat bewust geen knop naast — dat
    is een extra handeling voor iets wat je al hebt gekozen — maar dan moet het
    versturen wél ergens vandaan komen; zonder dit gebeurde er niets.

    Zonder JavaScript verschijnt de knop uit <noscript> en werkt hetzelfde
    formulier gewoon op de oude manier.
  */
  document.querySelectorAll('[data-sort] select').forEach((select) => {
    select.addEventListener('change', () => select.form.submit());
  });

  /*
    Het verloop aan de rand van de stappenrij alleen tonen waar er ook echt
    iets achter ligt.

    De rij is links uitgelijnd op smalle schermen en rechts op brede, en met
    `safe` valt die uitlijning bij overloop terug naar het begin. Aan welke
    kant het verborgen deel zit is daarmee niet uit de opmaak af te leiden —
    de schuifpositie weet het wel. Past alles, dan staan beide kanten op nul
    en is er geen verloop; dat was eerder wél zo, en dan vervaagde de eerste
    pil zonder dat er iets achter zat.
  */
  document.querySelectorAll('.collection-steps__row').forEach((row) => {
    // Een pixel speling: bij zoomen en op schermen met een fractionele
    // schaal komen deze maten zelden precies op elkaar uit.
    const speling = 1;

    const sync = () => {
      const begin = row.scrollLeft > speling;
      const eind = row.scrollWidth - row.clientWidth - row.scrollLeft > speling;
      row.style.setProperty('--fade-start', begin ? 'var(--steps-fade)' : '0px');
      row.style.setProperty('--fade-end', eind ? 'var(--steps-fade)' : '0px');
    };

    sync();
    row.addEventListener('scroll', sync, { passive: true });
    // Meebewegen met het venster: bij een bredere baan past er ineens meer.
    new ResizeObserver(sync).observe(row);
  });

  /*
    Toepassen kan pas als er iets te wijzigen valt.

    Het uitzetten gebeurt hier en niet in de markup: zonder JavaScript is dit
    formulier de enige manier om te filteren, en dan moet de knop het gewoon
    doen vanaf het eerste moment.

    Er wordt vergeleken met de begintoestand en niet simpelweg aangezet bij de
    eerste wijziging. Zet je een vinkje aan en meteen weer uit, dan sta je weer
    waar je begon en valt er nog steeds niets toe te passen.
  */
  document.querySelectorAll('.collection__filters-form').forEach((form) => {
    const apply = form.querySelector('.collection__apply');
    if (!apply) return;

    const state = () => new URLSearchParams(new FormData(form)).toString();
    const start = state();
    const sync = () => {
      apply.disabled = state() === start;
    };

    sync();

    // `change` dekt de vinkjes, `input` de prijsvelden — die geven pas een
    // change als je het veld verlaat.
    ['change', 'input'].forEach((name) => form.addEventListener(name, sync));

    /*
      Sluiten met een openstaande wijziging past hem alsnog toe.

      Wie een vinkje zet en de lade wegklikt, bedoelt niet "laat maar" — dat
      vinkje was de hele reden om de lade te openen. Filteren is bovendien
      omkeerbaar, dus toepassen is hier de veilige aanname en weggooien niet.

      Het hangt aan `toggle` en niet aan de sluitknop: zo geldt het voor elke
      manier van sluiten, ook die het script van de lade zelf afhandelt —
      ernaast klikken, Escape, of nog eens op Filteren tikken.
    */
    const drawer = form.closest('details[data-drawer]');
    if (!drawer) return;

    drawer.addEventListener('toggle', () => {
      if (!drawer.open && state() !== start) form.submit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  /*
    Pijlen voor de rij. Vegen werkt zonder dit; dit is de muis-variant.

    Anders dan bij de reviews wordt er niet rondgelopen. Daarvoor zou de rij
    gedupliceerd moeten worden, en een productkaart bevat een snelknop en een
    hartje — die wil je niet twee keer op de pagina hebben staan.
  */
  class FeaturedSlider {
    constructor(root) {
      this.track = root.querySelector('[data-featured-track]');
      const prev = root.querySelector('[data-featured-prev]');
      const next = root.querySelector('[data-featured-next]');
      if (!this.track || !prev || !next) return;

      prev.addEventListener('click', () => this.step(-1));
      next.addEventListener('click', () => this.step(1));
    }

    step(direction) {
      const card = this.track.querySelector('.featured__item');
      if (!card) return;

      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const stride = card.getBoundingClientRect().width + gap;
      const max = this.track.scrollWidth - this.track.clientWidth;
      const at = this.track.scrollLeft;

      // Eerst tegen de rand aan, en pas bij een klik óp die rand naar de
      // andere kant. Bij weinig overschot schiet een hele stap er anders
      // overheen en lijkt de pijl niets te doen.
      let target;
      if (direction > 0) {
        target = at >= max - 1 ? 0 : Math.min(at + stride, max);
      } else {
        target = at <= 1 ? max : Math.max(at - stride, 0);
      }

      this.track.scrollTo({ left: target, behavior: 'smooth' });
    }
  }

  document.querySelectorAll('.featured__slider').forEach((root) => new FeaturedSlider(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  /*
    De kolommen staan in de HTML open, zodat ze zonder JavaScript gewoon
    zichtbaar zijn. Op een telefoon klappen ze dicht en worden ze klikbaar.
  */
  class FooterColumns {
    constructor(footer) {
      this.columns = Array.from(footer.querySelectorAll('[data-footer-column]'));
      if (!this.columns.length) return;

      this.query = window.matchMedia('(min-width: 750px)');
      this.apply();
      this.query.addEventListener('change', () => this.apply());
    }

    apply() {
      const isDesktop = this.query.matches;
      this.columns.forEach((column) => {
        column.open = isDesktop;
      });
    }
  }

  document.querySelectorAll('.footer').forEach((footer) => new FooterColumns(footer));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  /*
    De uitklappers werken op zichzelf al met <details>: zonder JavaScript
    openen en sluiten ze gewoon, en het zoekformulier post naar de zoekpagina.
    Dit script voegt alleen toe wat CSS niet kan — waaronder de uitgaande
    animatie, want <details> gooit zijn inhoud bij het sluiten direct weg.
  */
  class HeaderDisclosures {
    constructor(header) {
      this.header = header;
      this.section = header.closest('.shopify-section') || header;
      this.panels = Array.from(header.querySelectorAll('details[data-single-open], details.header__drawer'));

      this.panels.forEach((panel) => {
        const summary = panel.querySelector('summary');

        // Sluiten onderscheppen zodat de uitgaande animatie kan spelen.
        summary.addEventListener('click', (event) => {
          if (!panel.open) return;
          event.preventDefault();
          this.close(panel);
        });

        panel.addEventListener('toggle', () => {
          if (panel.open) this.onOpen(panel);
          this.syncStacking();
        });
      });

      header.addEventListener('click', (event) => {
        if (event.target.closest('[data-close]')) this.closeAll();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        this.closeAll();

        /*
          Het mega menu staat open zolang de focus erin zit — dat regelt CSS
          met :focus-within. Sluiten is hier dus de focus weghalen; er valt
          geen paneel te sluiten dat het script zelf openzette.
        */
        const focused = document.activeElement;
        if (focused && focused.closest && focused.closest('.header__mega')) focused.blur();
      });
    }

    /*
      Vangnet voor browsers zonder :has() — zie de regel bij
      .header-has-open-panel. Het toggle-event vuurt bij openen én sluiten,
      dus deze klasse volgt vanzelf.
    */
    syncStacking() {
      this.section.classList.toggle(
        'header-has-open-panel',
        this.panels.some((panel) => panel.open)
      );
    }

    onOpen(opened) {
      this.panels.forEach((panel) => {
        if (panel !== opened) this.close(panel);
      });

      // Cursor meteen in het zoekveld; dat kan CSS niet.
      const input = opened.querySelector('input[type="search"]');
      if (input) input.focus();
    }

    async close(panel) {
      if (!panel.open || panel.hasAttribute('data-closing')) return;

      panel.setAttribute('data-closing', '');

      /*
        De lopende animaties uitlezen in plaats van een vaste vertraging: gaat
        de duur in CSS omhoog of omlaag, dan volgt dit vanzelf. Staan er geen
        animaties — bij prefers-reduced-motion — dan is de lijst leeg en sluit
        het paneel meteen.
      */
      const animations = Array.from(panel.querySelectorAll('[data-animated]')).flatMap((element) =>
        element.getAnimations ? element.getAnimations() : []
      );

      await Promise.allSettled(animations.map((animation) => animation.finished));

      panel.open = false;
      panel.removeAttribute('data-closing');

      /*
        Het tweede niveau in de lade staat buiten deze lijst — het is een kale
        <details> zonder script. Zonder dit staat het bij het volgende openen
        nog steeds open en kijk je meteen tegen het submenu aan.
      */
      panel.querySelectorAll('details[open]').forEach((level) => {
        level.open = false;
      });
    }

    closeAll() {
      this.panels.forEach((panel) => this.close(panel));
    }
  }

  /*
    Toevoegen aan de winkelwagen opent de lade in plaats van naar de
    winkelwagenpagina te springen. Zonder JavaScript doet het formulier gewoon
    wat het altijd deed: posten en doorsturen naar /cart.
  */
  class CartDrawer {
    constructor(header) {
      this.header = header;
      this.details = header.querySelector('.header__cart');
      if (!this.details) return;

      // Op document-niveau: de formulieren staan buiten de header, en er komen
      // er meer bij naarmate er secties met een snelknop bijkomen.
      document.addEventListener('submit', (event) => this.onSubmit(event));
      this.details.addEventListener('click', (event) => this.onQuantityClick(event));
      this.startCutoff();
    }

    get root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    async onSubmit(event) {
      const form = event.target.closest('form[action*="/cart/add"]');
      if (!form) return;

      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      if (button) button.setAttribute('aria-busy', 'true');

      /*
        Een kenmerk zonder waarde slaat Shopify wél op: dan staat er bij elke
        bestelregel "Cadeauverpakking" zonder antwoord. Lege kenmerken gaan er
        daarom hier uit, zodat alleen een gekozen cadeauverpakking meekomt.
      */
      const body = new FormData(form);
      for (const [name, value] of [...body.entries()]) {
        if (name.startsWith('properties[') && value === '') body.delete(name);
      }

      try {
        const response = await fetch(`${this.root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body,
        });

        if (!response.ok) throw new Error(response.statusText);

        await this.refresh();
        this.details.open = true;
      } catch (error) {
        // Lukt het niet, dan alsnog de gewone weg: posten en doorsturen.
        form.submit();
      } finally {
        if (button) button.removeAttribute('aria-busy');
      }
    }

    /*
      De inhoud van de lade komt uit de header-sectie zelf, opnieuw gerenderd
      via de Section Rendering API. Zo staat de opmaak op één plek in Liquid en
      hoeft dit script geen winkelwagen na te bouwen in JavaScript.
    */
    onQuantityClick(event) {
      const button = event.target.closest('.cart-item__quantity button');
      if (!button) return;

      const line = button.closest('[data-line]');
      if (!line) return;

      this.change(line.dataset.line, button.dataset.quantity);
    }

    async change(line, quantity) {
      try {
        await fetch(`${this.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
        });
        await this.refresh();
      } catch (error) {
        // Lukt het niet, dan is de winkelwagenpagina de terugvaloptie.
        window.location.href = `${this.root}cart`;
      }
    }

    /*
      De klok telt door vanaf de waarde die Liquid heeft berekend. Dat gebeurt
      in de tijdzone van de winkel, niet die van de bezoeker — anders zou
      iemand in een andere tijdzone een verkeerde deadline zien.
    */
    startCutoff() {
      const cutoff = this.header.querySelector('[data-cutoff]');
      if (!cutoff) return;

      clearInterval(this.timer);
      let left = Number(cutoff.dataset.cutoff);
      const output = cutoff.querySelector('[data-cutoff-time]');

      const tick = () => {
        if (left <= 0) {
          cutoff.remove();
          clearInterval(this.timer);
          return;
        }

        const hours = String(Math.floor(left / 3600)).padStart(2, '0');
        const minutes = String(Math.floor((left % 3600) / 60)).padStart(2, '0');
        const seconds = String(left % 60).padStart(2, '0');
        output.textContent = `${hours}:${minutes}:${seconds}`;
        left -= 1;
      };

      tick();
      this.timer = setInterval(tick, 1000);
    }

    async refresh() {
      const response = await fetch(`${this.root}?sections=header`);
      const data = await response.json();
      const fresh = new DOMParser().parseFromString(data.header, 'text/html');

      /*
        Stond de lade al open, dan is de vorige stand van de balk het
        vertrekpunt voor de animatie. De inhoud wordt namelijk in één keer
        vervangen; zonder dit begint de nieuwe balk meteen op zijn eindwaarde
        en zie je hem niet vollopen.
      */
      const wasOpen = this.details.open;
      const previous = this.details.querySelector('[data-progress]');
      const from = previous ? previous.style.getPropertyValue('--progress') : null;

      const body = fresh.querySelector('.header__cart-body');
      const target = this.header.querySelector('.header__cart-body');
      if (body && target) target.innerHTML = body.innerHTML;

      if (wasOpen && from) this.animateProgress(from);

      const summary = this.details.querySelector('summary');
      const nextCount = fresh.querySelector('.header__cart-count');
      const currentCount = summary.querySelector('.header__cart-count');

      if (nextCount && currentCount) currentCount.textContent = nextCount.textContent;
      else if (nextCount) summary.appendChild(nextCount);
      else if (currentCount) currentCount.remove();

      // De voet verschijnt en verdwijnt met de inhoud van de winkelwagen.
      const nextFoot = fresh.querySelector('.header__cart-foot');
      const currentFoot = this.details.querySelector('.header__cart-foot');
      if (nextFoot && currentFoot) currentFoot.replaceWith(nextFoot);
      else if (nextFoot) this.details.querySelector('.header__cart-panel').appendChild(nextFoot);
      else if (currentFoot) currentFoot.remove();

      this.startCutoff();
    }

    animateProgress(from) {
      const track = this.details.querySelector('[data-progress]');
      if (!track) return;

      const to = track.style.getPropertyValue('--progress');
      if (from === to) return;

      track.style.setProperty('--progress', from);

      /*
        Twee frames wachten: één om de beginwaarde te laten doorrekenen, één om
        de wijziging als overgang te laten tellen. In één frame ziet de browser
        alleen de eindwaarde en gebeurt er niets.
      */
      requestAnimationFrame(() => {
        requestAnimationFrame(() => track.style.setProperty('--progress', to));
      });
    }
  }

  /*
    Zoekresultaten terwijl je typt.

    De resultaten komen als kant-en-klare HTML uit de sectie
    predictive-search, opgehaald via /search/suggest. Dit script beslist dus
    alleen wanneer er gezocht wordt, niet hoe het eruitziet.

    Zonder JavaScript verandert er niets: het formulier post naar de
    zoekpagina, zoals het altijd al deed.
  */
  class PredictiveSearch {
    constructor(header) {
      this.input = header.querySelector('.header__search-input');
      this.results = header.querySelector('[data-search-results]');
      if (!this.input || !this.results) return;

      this.input.addEventListener('input', () => this.onType());

      // Sluit het paneel, dan ook de resultaten weg: bij het volgende openen
      // hoort er niet nog een oude lijst te staan.
      const panel = this.input.closest('details');
      if (panel) {
        panel.addEventListener('toggle', () => {
          if (!panel.open) this.clear();
        });
      }
    }

    get root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    onType() {
      clearTimeout(this.timer);

      const term = this.input.value.trim();

      /*
        Onder de twee tekens levert zoeken vooral ruis op, en het zijn precies
        de toetsaanslagen waarvan er de meeste zijn.
      */
      if (term.length < 2) {
        this.clear();
        return;
      }

      // Wachten tot het typen even stilvalt: anders gaat er een verzoek per
      // letter de deur uit en komen de antwoorden door elkaar terug.
      this.timer = setTimeout(() => this.search(term), 220);
    }

    async search(term) {
      // Het vorige verzoek afbreken, zodat een traag antwoord op een oudere
      // zoekterm niet over een nieuwer resultaat heen valt.
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();

      try {
        let markup = await this.fetch(term);

        /*
          Geen producten gevonden? Dan nog één keer met alleen het begin van
          het woord.

          Shopify vangt een vergeten of dubbele letter zelf op, maar niet het
          omdraaien van twee letters — en dat is juist de fout die je maakt als
          je snel typt. Bij "kettign" komen er wel collecties terug maar geen
          producten; "kett" levert ze wel op. Het begin van een woord is bijna
          altijd goed getypt, dus daar knippen we naartoe terug.

          Op het aantal producten kijken en niet op "is er iets": met alleen
          twee collectie-links lijkt er resultaat te zijn terwijl juist mist
          waar iemand voor zoekt.

          Vier tekens, gemeten op deze catalogus: "oorbleen" en "kettign"
          leveren niets op, "oorb" en "kett" wel. Meer overhouden helpt niet —
          bij "oorbleen" zit de fout al op plek vijf, dus daar moet je onder.
          Nog korter maakt het te vaag: dan komt bij elke mistyped zoekterm
          zo'n beetje de halve collectie terug.
        */
        if (this.countProducts(markup) === 0 && term.length > 4) {
          const stem = term.slice(0, 4);
          const fallback = await this.fetch(stem);

          // Alleen overnemen als het écht meer oplevert — anders raak je de
          // pagina's kwijt die de oorspronkelijke zoekterm wél vond.
          if (this.countProducts(fallback) > 0) markup = fallback;
        }

        this.results.innerHTML = markup;
      } catch (error) {
        // Afgebroken verzoeken zijn geen fout; de rest laat de lijst staan
        // zoals hij was in plaats van hem leeg te maken.
        if (error.name !== 'AbortError') this.clear();
      }
    }

    async fetch(term) {
      const query = new URLSearchParams({
        q: term,
        'resources[type]': 'product,collection,page',
        'resources[limit]': 6,
        'resources[options][unavailable_products]': 'hide',
        section_id: 'predictive-search',
      });

      const response = await fetch(`${this.root}search/suggest?${query}`, {
        signal: this.controller.signal,
      });

      if (!response.ok) throw new Error(response.statusText);

      const html = await response.text();
      const fresh = new DOMParser().parseFromString(html, 'text/html');
      const found = fresh.querySelector('.predictive');

      return found ? found.outerHTML : '';
    }

    countProducts(markup) {
      return (markup.match(/predictive__item/g) || []).length;
    }

    clear() {
      this.results.innerHTML = '';
    }
  }

  document.querySelectorAll('.header').forEach((header) => {
    new HeaderDisclosures(header);
    new CartDrawer(header);
    new PredictiveSearch(header);

    /*
      De sectie-wrapper komt van Shopify en zit buiten deze Liquid, dus de
      class kan er niet in de markup op. De CSS-selector met :has() doet
      hetzelfde; deze regel is het vangnet voor het geval de opbouw van die
      wrapper afwijkt van wat de selector verwacht.
    */
    if (header.classList.contains('header--sticky')) {
      const section = header.closest('.shopify-section');
      if (section) section.classList.add('header-is-sticky');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  /*
    Wie in zijn systeem heeft aangegeven minder beweging te willen, krijgt een
    stilstaand beeld. Dat is met CSS niet te regelen: `prefers-reduced-motion`
    kan een animatie stoppen, maar niet het afspelen van een video. De poster
    blijft staan, dus de hero ziet er verder hetzelfde uit.
  */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('video.hero__video').forEach((video) => {
      video.autoplay = false;
      video.pause();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /*
    De galerij is scroll-snap, dus vegen werkt zonder dit script. De miniaturen
    scrollen de bijbehorende foto in beeld en houden bij welke actief is.
  */
  class ProductGallery {
    constructor(root) {
      this.slides = root.querySelector('[data-product-slides]');
      this.thumbs = root.querySelector('[data-product-thumbs]');
      if (!this.slides || !this.thumbs) return;

      this.thumbs.querySelectorAll('[data-media-id]').forEach((thumb) => {
        thumb.addEventListener('click', () => this.show(thumb.dataset.mediaId));
      });

      const prev = root.querySelector('[data-product-prev]');
      const next = root.querySelector('[data-product-next]');
      if (prev) prev.addEventListener('click', () => this.step(-1));
      if (next) next.addEventListener('click', () => this.step(1));

      this.slides.addEventListener('scroll', () => this.sync(), { passive: true });
      this.sync();
    }

    step(direction) {
      const width = this.slides.clientWidth;
      const max = this.slides.scrollWidth - width;
      let target = this.slides.scrollLeft + width * direction;

      // Rondlopen, zodat een pijl nooit in een dood einde eindigt.
      if (target > max + 1) target = 0;
      if (target < 0) target = max;

      this.slides.scrollTo({ left: target, behavior: 'smooth' });
    }

    show(id) {
      const slide = this.slides.querySelector(`[data-media-id="${id}"]`);
      if (slide) this.slides.scrollTo({ left: slide.offsetLeft - this.slides.offsetLeft, behavior: 'smooth' });
    }

    sync() {
      const index = Math.round(this.slides.scrollLeft / this.slides.clientWidth);
      const active = this.slides.querySelectorAll('[data-product-slide]')[index];
      if (!active) return;

      this.thumbs.querySelectorAll('[data-media-id]').forEach((thumb) => {
        const current = thumb.dataset.mediaId === active.dataset.mediaId;
        thumb.setAttribute('aria-current', String(current));
        // Houd de actieve miniatuur in beeld nu de rij kan scrollen.
        if (current) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      });
    }
  }

  document.querySelectorAll('.product').forEach((root) => new ProductGallery(root));

  /*
    Op mobiel verhuist de cadeaukeuze naar de koopbalk: de knop staat daar, en
    een keuze die bij die knop hoort moet er ook bij staan.

    Verplaatsen en niet dupliceren. Twee keuzerondjes met dezelfde naam binnen
    hetzelfde formulier vormen namelijk één groep — dan zou de ene schakelaar
    op "nee" springen zodra je bij de andere "ja" kiest.
  */
  const giftItem = document.querySelector('[data-gift-item]');
  /*
    Het koopkaartje linksonder. Twee waarnemers in plaats van een scrollteller:
    één kijkt of de koopknop in de pagina nog in beeld is, de ander of de
    voettekst al begint. Zo hoeft er niets uitgerekend te worden bij elke
    scrollstap, en klopt het ook als de pagina van hoogte verandert.
  */
  (() => {
    const dock = document.querySelector('[data-product-dock]');
    const koop = document.querySelector('.product__buy');
    if (!dock || !koop || !('IntersectionObserver' in window)) return;

    // Gericht op de voettekst-sectie, niet op het eerste `footer`-element in
    // de pagina: dat is tegenwoordig de voet van een reviewkaart, en die staat
    // middenin. De waarneming klopte dan precies omgekeerd.
    const voettekst =
      document.querySelector('.shopify-section-group-footer-group') ||
      document.querySelector('.footer');
    let koopZichtbaar = true;
    let voetZichtbaar = false;

    const bijwerken = () => {
      const tonen = !koopZichtbaar && !voetZichtbaar;
      dock.classList.toggle('product__dock--zichtbaar', tonen);
      // `hidden` blijft staan tot hij voor het eerst getoond wordt, zodat er
      // niets in beeld schiet voordat de waarnemers hun eerste meting doen.
      if (tonen) dock.removeAttribute('hidden');
    };

    new IntersectionObserver(([regel]) => {
      koopZichtbaar = regel.isIntersecting;
      bijwerken();
    }, {rootMargin: '0px 0px -80px 0px'}).observe(koop);

    if (voettekst) {
      new IntersectionObserver(([regel]) => {
        voetZichtbaar = regel.isIntersecting;
        bijwerken();
      }).observe(voettekst);
    }
  })();

  /*
    De koopbalk op mobiel weg zodra de voettekst begint. Dezelfde voettekst als
    hierboven, en om dezelfde reden gericht op de sectiegroep en niet op het
    eerste `footer`-element in de pagina.
  */
  (() => {
    const balk = document.querySelector('[data-sticky-buy]');
    const voettekst =
      document.querySelector('.shopify-section-group-footer-group') ||
      document.querySelector('.footer');
    if (!balk || !voettekst || !('IntersectionObserver' in window)) return;

    const waarnemer = new IntersectionObserver(([regel]) => {
      balk.classList.toggle('product__sticky--weg', regel.isIntersecting);
    });
    waarnemer.observe(voettekst);
  })();

  const stickyInner = document.querySelector('[data-sticky-buy] .product__sticky-inner');

  if (giftItem && stickyInner) {
    const home = giftItem.parentElement;
    const after = giftItem.nextElementSibling;
    const small = window.matchMedia('(max-width: 749px)');

    const place = () => {
      if (small.matches) {
        stickyInner.prepend(giftItem);
      } else {
        home.insertBefore(giftItem, after);
      }
    };

    place();
    small.addEventListener('change', place);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  /*
    Haalt Shopify's aanbevelingen op en vervangt de inhoud. Dat moet via een
    los verzoek: het `recommendations`-object is in Liquid pas gevuld wanneer
    de sectie via deze URL wordt opgehaald.

    Lukt het niet, dan blijft staan wat er al stond — de producten uit de
    gekozen collectie.
  */
  class RelatedProducts {
    constructor(root) {
      this.root = root;
      const productId = root.dataset.productId;
      if (!productId) return;

      // De URL komt uit Liquid, zodat hij de taal meeneemt (/de/, /en/).
      // Zonder taal geeft Shopify Nederlandse links terug.
      const url = root.dataset.recommendationsUrl || '/recommendations/products';

      // Altijd 10, het maximum: uitverkochte vallen in Liquid weg en de sectie
      // vult met de rest aan tot zijn eigen aantal.
      fetch(`${url}?section_id=${root.dataset.sectionId}&product_id=${productId}&limit=10`)
        .then((response) => (response.ok ? response.text() : Promise.reject()))
        .then((html) => this.replace(html))
        .catch(() => {});
    }

    replace(html) {
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.related__grid');
      const current = this.root.querySelector('.related__grid');

      if (!fresh || !fresh.children.length) return;

      if (current) {
        current.replaceWith(fresh);
      } else {
        this.root.querySelector('.related__inner').appendChild(fresh);
      }

      // De kaarten zijn net toegevoegd; hun pijlen moeten nog ingericht worden.
      if (window.initProductCards) window.initProductCards(this.root);
    }
  }

  document.querySelectorAll('[data-related]').forEach((root) => new RelatedProducts(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  /*
    Doorlopende carrousel bij de reviews.

    De rij staat er drie keer en we bewegen in het middelste blok. Daardoor is
    er altijd inhoud links én rechts. Zou een stap het middelste blok uit
    lopen, dan verspringt de positie eerst onzichtbaar een heel blok terug en
    pas daarna wordt er geschoven — dus je ziet nooit iets terugspringen.

    De boekhouding gaat via een teller en niet via de scrollpositie. Een eerdere
    versie zette de positie terug zodra `scrollend` binnenkwam, maar dat signaal
    komt niet betrouwbaar bij scrollen dat door een script is gestart. De
    carrousel dreef dan zijn veilige zone uit en kwam er niet meer in terug.
  */
  class ReviewSlider {
    constructor(root) {
      this.track = root.querySelector('[data-reviews-track]');
      const prev = root.querySelector('[data-reviews-prev]');
      const next = root.querySelector('[data-reviews-next]');
      if (!this.track || !prev || !next) return;

      this.originals = Array.from(this.track.children);
      if (this.originals.length < 2) return;

      this.duplicate();
      this.index = this.originals.length;
      requestAnimationFrame(() => this.jumpTo(this.index * this.stride));

      prev.addEventListener('click', () => this.step(-1));
      next.addEventListener('click', () => this.step(1));

      // Vegen laat de teller achter; die halen we terug uit de scrollpositie
      // zodra de vinger van het scherm is.
      let timer;
      this.track.addEventListener('scroll', () => {
        clearTimeout(timer);
        timer = setTimeout(() => this.resync(), 140);
      });
    }

    duplicate() {
      // Twee kopieën, voor en na. Schermlezers slaan ze over, anders hoor je
      // elke review drie keer.
      const before = document.createDocumentFragment();
      const after = document.createDocumentFragment();

      this.originals.forEach((item) => {
        [before, after].forEach((target) => {
          const copy = item.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          target.append(copy);
        });
      });

      this.track.prepend(before);
      this.track.append(after);
    }

    get stride() {
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return this.originals[0].getBoundingClientRect().width + gap;
    }

    step(direction) {
      const count = this.originals.length;
      let next = this.index + direction;

      if (next >= count * 2 || next < count) {
        const shift = next >= count * 2 ? -count : count;
        this.index += shift;
        next += shift;
        this.jumpTo(this.index * this.stride);
      }

      this.index = next;
      this.track.scrollTo({ left: next * this.stride, behavior: 'smooth' });
    }

    resync() {
      const count = this.originals.length;
      let index = Math.round(this.track.scrollLeft / this.stride);

      if (index >= count * 2) index -= count;
      else if (index < count) index += count;
      else {
        this.index = index;
        return;
      }

      this.index = index;
      this.jumpTo(index * this.stride);
    }

    jumpTo(position) {
      /*
        Snap uit tijdens de sprong, anders trekt de browser de positie naar zijn
        eigen dichtstbijzijnde kaart. Pas een frame later weer aan, want binnen
        dezelfde stap zou hij alsnog corrigeren.
      */
      this.track.style.scrollSnapType = 'none';
      this.track.scrollLeft = position;
      requestAnimationFrame(() => {
        this.track.style.scrollSnapType = '';
      });
    }
  }

  document.querySelectorAll('.reviews__slider').forEach((root) => new ReviewSlider(root));

  /*
    De foto's uitvergroten. Eén dialoogvenster voor de hele sectie: bij drie
    foto's per kaart zouden dat er anders tientallen worden.

    `dialog` doet het zware werk zelf — Escape sluit, de achtergrond wordt
    inert, en de focus komt terug waar hij was. Het vastzetten van de pagina
    eronder gaat via het `scroll-lock`-attribuut, dezelfde afspraak die de rest
    van het thema gebruikt.
  */
  (() => {
    const lightbox = document.querySelector('[data-review-lightbox]');
    if (!lightbox) return;

    const beeld = lightbox.querySelector('[data-review-lightbox-image]');
    let fotos = [];
    let index = 0;

    function toon(nieuw) {
      if (!fotos.length) return;
      // Rondlopen: voorbij de laatste kom je weer bij de eerste uit.
      index = (nieuw + fotos.length) % fotos.length;
      beeld.src = fotos[index];
    }

    function open(knop) {
      const rij = knop.closest('.review__images') ?? knop.parentElement;
      const knoppen = Array.from(rij.querySelectorAll('[data-review-photo]'));
      fotos = knoppen.map((k) => k.dataset.reviewPhoto);
      lightbox.toggleAttribute('data-alleen-een', fotos.length < 2);
      toon(knoppen.indexOf(knop));
      lightbox.showModal();
    }

    document.addEventListener('click', (event) => {
      const knop = event.target.closest('[data-review-photo]');
      if (knop) {
        open(knop);
        return;
      }
      if (event.target.closest('[data-review-lightbox-prev]')) return toon(index - 1);
      if (event.target.closest('[data-review-lightbox-next]')) return toon(index + 1);

      // Naast de foto klikken sluit ook. De dialoog vult het scherm, dus we
      // kijken of de klik buiten het beeld en de knoppen viel.
      if (
        event.target.closest('[data-review-lightbox-close]') ||
        ((event.target === lightbox || event.target.closest('.review-lightbox__binnen')) &&
          !event.target.closest('.review-lightbox__beeld'))
      ) {
        lightbox.close();
      }
    });

    lightbox.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') toon(index - 1);
      if (event.key === 'ArrowRight') toon(index + 1);
    });

    // Vegen op een aanraakscherm. Vijftig pixels is genoeg om een veeg van
    // een schuivende vinger te onderscheiden.
    let startX = null;
    lightbox.addEventListener('touchstart', (event) => {
      startX = event.changedTouches[0].clientX;
    }, {passive: true});

    lightbox.addEventListener('touchend', (event) => {
      if (startX === null) return;
      const verschil = event.changedTouches[0].clientX - startX;
      if (Math.abs(verschil) > 50) toon(verschil < 0 ? index + 1 : index - 1);
      startX = null;
    }, {passive: true});

    lightbox.addEventListener('close', () => {
      beeld.removeAttribute('src');
      fotos = [];
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-video"] && !Shopify.designMode) return;
  try {
    
  /*
    Klikken vervangt de poster door de video. De inhoud staat in een <template>,
    dus tot dat moment wordt er niets geladen — geen videobestand, en bij een
    externe video ook geen script of cookie van YouTube of Vimeo.
  */
  class TextVideo {
    constructor(root) {
      const button = root.querySelector('[data-video-play]');
      const template = root.querySelector('[data-video-source]');
      if (!button || !template) return;

      button.addEventListener('click', () => {
        root.appendChild(template.content.cloneNode(true));
        // De poster blijft staan, alleen onzichtbaar: zonder vaste verhouding
        // is hij het enige dat het kader zijn hoogte geeft. Verwijderen laat
        // de speler — die er absoluut overheen ligt — inklappen tot 300x150.
        root.classList.add('text-video__media--speelt');
        button.remove();
      }, {once: true});
    }
  }

  document.querySelectorAll('[data-video]').forEach((root) => new TextVideo(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
  /*
    De lijst staat in de browser, dus de kaarten worden hier opgehaald. Per
    bewaard sieraad één verzoek naar dezelfde kaart die overal op de site staat.

    De verzoeken gaan tegelijk uit maar worden op volgorde ingevoegd, anders
    springt de lijst bij elke verversing in een andere volgorde.
  */
  class Wishlist {
    constructor(root) {
      this.grid = root.querySelector('[data-wishlist-grid]');
      this.empty = root.querySelector('[data-wishlist-empty]');
      this.unavailable = root.querySelector('[data-wishlist-unavailable]');
      if (!this.grid) return;

      this.render();
      document.addEventListener('wishlist:change', () => this.render());
    }

    async render() {
      const handles = window.wishlist ? window.wishlist.read() : [];

      if (handles.length === 0) {
        this.grid.hidden = true;
        this.grid.replaceChildren();
        this.empty.hidden = false;
        if (this.unavailable) this.unavailable.hidden = true;
        return;
      }

      this.empty.hidden = true;

      const cards = (await Promise.all(handles.map((handle) => this.card(handle)))).filter(Boolean);

      this.grid.replaceChildren(...cards);
      this.grid.hidden = cards.length === 0;

      /*
        Wat er niet terugkwam blijft gewoon bewaard — een product kan tijdelijk
        op concept staan. Alleen melden dat het er even niet is; weggooien zou
        betekenen dat iemand zijn lijst kwijtraakt door een tijdelijke actie in
        de admin.
      */
      if (this.unavailable) this.unavailable.hidden = cards.length === handles.length;

      // De kaarten zijn net ingevoegd: pijlen aanzetten en hartjes bijwerken.
      window.initProductCards?.(this.grid);
      window.wishlist?.sync();
    }

    async card(handle) {
      try {
        // Via de winkelwortel, zodat het ook klopt op een taalsubmap.
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}products/${handle}?section_id=wishlist-card`);
        if (!response.ok) return null;

        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        return html.querySelector('.product-card');
      } catch (error) {
        // Verwijderd product of geen verbinding: die kaart slaan we over,
        // de rest van de lijst blijft gewoon staan.
        return null;
      }
    }
  }

  document.querySelectorAll('.wishlist').forEach((root) => new Wishlist(root));

  } catch(e) { console.error(e); }
})();
})();
